import React from 'react';
import {
  Typography,
  Paper,
  List,
  Button,
  Chip,
  Card,
  CardContent,
  CardActions,
  Box
} from '@mui/material';

const JobsList = ({ jobs, handleJobSelect }) => {
  return (
    <Paper elevation={3} sx={{ padding: 4, width: '100%' }}>
      <Typography component="h1" variant="h5" sx={{ mb: 3 }}>
        Your Job Posts
      </Typography>
      <Typography variant="body2" sx={{ mb: 3, color: 'text.secondary' }}>
        Select a job post to add automation for auto-replies:
      </Typography>
      
      <List sx={{ width: '100%' }}>
        {jobs.map((job) => (
          <Card key={job.id} sx={{ mb: 2 }}>
            <CardContent>
              <Box display="flex" justifyContent="space-between" alignItems="flex-start">
                <Box>
                  <Typography variant="h6" component="h3">
                    {job.title}
                  </Typography>
                  <Box sx={{ mt: 1, mb: 1 }}>
                    <Chip 
                      label={job.status} 
                      color={job.isPublished ? 'success' : 'default'}
                      size="small"
                      sx={{ mr: 1 }}
                    />
                    {job.responsesCount > 0 && (
                      <Chip 
                        label={`${job.responsesCount} new responses`} 
                        color="primary"
                        size="small"
                      />
                    )}
                  </Box>
                  <Typography variant="body2" color="text.secondary">
                    Published: {job.publicationDate} • {job.views} views • {job.totalResponses} total responses
                  </Typography>
                </Box>
              </Box>
            </CardContent>
            <CardActions>
              <Button 
                size="small" 
                variant="contained"
                onClick={() => handleJobSelect(job)}
                disabled={!job.isPublished}
              >
                Add Auto Reply
              </Button>
              <Button 
                size="small" 
                href={job.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                View Job
              </Button>
            </CardActions>
          </Card>
        ))}
      </List>
      
      {jobs.length === 0 && (
        <Typography variant="body1" sx={{ textAlign: 'center', mt: 4 }}>
          No job posts found.
        </Typography>
      )}
    </Paper>
  );
};

export default JobsList; 